import React from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

//Local Libraries
import phrasebookLoad from "../../i18n"; import { gisRoutes } from "../../routes/routes";
import * as token from '../../helpers/token';
import { accountTypesConstants } from '../../constants';

// Constants
const phrasebook = phrasebookLoad()
class PageNotFound extends React.Component {
  constructor(props) {
    super(props);
    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];
    // reset login status
  }
  render() {
    return <div class="container-xs">
      <div class="box p-1 p-sm-3 p-lg-3 text-center">
        <div class="rich-icon">
          <img src="https://skyframework.pccwglobal.com/img/error.svg" />
        </div>
        <h3>{phrasebook.common.error404}</h3>
        <p class="mb-2">{phrasebook.common.error404_description}</p>
        <Link to={gisRoutes.dashboard[this.account_type_logged]} class="btn btn-main">{phrasebook.common.back_to_homepage}</Link>
      </div>
    </div>
  }
}

function mapStateToProps(state) {
  const { loggingIn } = state.authentication;
  return {
    loggingIn
  };
}

const pagenotfound = connect(mapStateToProps)(PageNotFound);

export default (pagenotfound);
